import {projects} from './Research.jsx';
import { Link } from 'react-router-dom';
const includeIds = [2 ];

const filterprojects = projects.filter(item => includeIds.includes(item.id));
const Home = () => {
            return (
                    <main className="flex-grow flex flex-col justify-center items-center p-6 overflow-auto">
                <div className="text-center w-full max-w-5xl mx-auto">
                    <div className="text-center w-full pb-16 pt-12">
                        {/* I am Heying, graduated from Xiamen University, and got my bachelor degree of economics.
                        <br />I am interested in statistical research and now I am in a gap year preparing to study in data science in univeristy of California, Los Angeles.
                        <br />Currently my interested topics are <b> deep survival models </b> and <b>targeted maximum likelihood estimation</b>. */}
                        
                        <a href='tel:415-359-7772'>415-359-7772</a>
                        <br/><a href='mailto:study@heyingdu.com'>study@heyingdu.com</a>
                        <br/><b>Causal Inference; Bayesian Neural Network; Sports Data Analysis</b> 
                    </div>
                    <div className="text-left w-full mt-8">
                        {filterprojects.map((project) => (
                            <div key={project.id} className="mb-16">
                            <Link to={project.url} className="cursor-pointer hover:opacity-80 transition-opacity inline-block">
                                <h2 className="text-xl md:text-2xl font-bold mb-2 relative group">
                                    {project.title}
                                    <span className="block h-[1px] bg-gradient-to-r from-black to-gray-400 mt-1 w-[125%] group-hover:w-full transition-all duration-500"></span>
                                </h2>
                            </Link>
                            <div className="pl-8 text-left text-gray-700 text-sm md:text-base [&_a]:no-underline [&_a]:text-blue-700 [&_a:hover]:text-blue-700 [&_a:hover]:opacity-80 ">
                                {project.description}
                            </div>
                        </div>
                        ))}
                    </div>
                </div>
            </main>
            );
        };

export default Home;